function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.2082 11.6889C12.8484 11.6889 14.9998 9.07361 14.9998 5.85555C14.9998 2.63749 12.8484 0.0222168 10.2082 0.0222168C7.56796 0.0222168 5.4165 2.63749 5.4165 5.85555C5.4165 9.07361 7.57275 11.6889 10.2082 11.6889ZM10.2084 1.48055C12.0628 1.48055 13.5626 3.42499 13.5626 5.85555C13.5626 8.28611 12.0628 10.2305 10.2084 10.2305C8.35404 10.2305 6.85425 8.28611 6.85425 5.85555C6.85425 3.42499 8.35404 1.48055 10.2084 1.48055Z",
  fill: "#FAFBFB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.4634 11.2758C14.0593 11.2367 13.6989 11.5221 13.6585 11.9134C13.6181 12.3047 13.913 12.6536 14.3171 12.6927C16.5864 12.9509 18.3445 14.7364 18.5024 16.9434H1.49756C1.67048 14.7428 3.42097 12.965 5.68293 12.6927C6.08704 12.6536 6.38187 12.3047 6.34146 11.9134C6.30105 11.5221 5.9407 11.2367 5.53659 11.2758C5.48293 11.2758 0 11.8803 0 17.6471C0 18.0384 0.327597 18.3556 0.731707 18.3556H19.2683C19.6724 18.3556 20 18.0384 20 17.6471C20 11.8803 14.5171 11.2758 14.4634 11.2758Z",
  fill: "#FAFBFB"
});

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.8a03ef0c.svg";
export { ForwardRef as ReactComponent };